import { Component, DoCheck } from '@angular/core';

import { ColorOptions } from './color-options';
import { CellContext, IIdentity } from '.';
import { CellComponent } from './cell-component.model';

@Component({
  template: '',
})
export abstract class ColorComponent<T extends IIdentity>
  implements CellComponent<T>, DoCheck
{
  context!: CellContext<T>;
  colorOptions: ColorOptions;

  // get the color options from context depending of the type of cell config
  protected abstract get contextColorOptions(): ColorOptions;

  ngDoCheck(): void {
    if (this.context?.config) {
      this.colorOptions = this.contextColorOptions;
    }
  }
}
